<template>
    <badge :type="params.value" />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({});
</script>
